import type {DeliveryProgressStep, OrderReportTrip} from '../../types';

import {useMemo} from 'react';

import MultiStepProgressBar from './components/MultiStepProgressBar/MultiStepProgressBar';
import {EXPRESS_DELIVERY_STEPS, OWN_DELIVERY_STEPS} from './constants';

type DeliveryStatusProps = {
  deliveryType?: string;
  trip?: OrderReportTrip;
};

const DeliveryStatus: React.FC<DeliveryStatusProps> = ({deliveryType, trip}) => {
  const steps = useMemo<DeliveryProgressStep[]>(() => {
    if (!deliveryType) {
      return [];
    }

    return deliveryType === 'ZF_EXPRESS' ? EXPRESS_DELIVERY_STEPS : OWN_DELIVERY_STEPS;
  }, [deliveryType]);

  const currentStep = useMemo(() => {
    if (steps.length === 0 || !trip) {
      return null;
    }

    return (
      steps.findLast((step) => step.status.toLowerCase() === String(trip.status).toLowerCase()) ??
      null
    );
  }, [steps, trip]);

  return (
    <div className="relative flex min-h-15 w-full flex-col gap-2.5 rounded-xl bg-orange-main p-3 text-white transition-transform duration-300 ease-in-out">
      <div className="flex items-center justify-between text-body-sm">
        <span className="font-medium">{currentStep?.title}</span>
      </div>
      <MultiStepProgressBar currentStep={currentStep} steps={steps} />
    </div>
  );
};

export default DeliveryStatus;
